import { type Href, Redirect } from 'expo-router';
import React from 'react';

import { clearRedirectPath, getStoredRedirectPath } from '../helpers';

const HandleRedirectFromStorage = () => {
    const redirectPath = getStoredRedirectPath(30); // ignore the redirect path if it's older than 30 minutes

    if (redirectPath !== undefined) {
        clearRedirectPath(); // clear after use, as this is meant for one-time use

        // Redirect to the route in local storage, written by RedirectIfNotAuthenticated.
        return <Redirect href={redirectPath as Href} />;
    }

    return <Redirect href="/" />;
};

export default HandleRedirectFromStorage;
